import React from 'react'

export const Tick = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.33366 2.5L3.75033 7.08333L1.66699 5"
      stroke="black"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
